export type Stamp = {
  id: number;
  category: string;
  name: string;
  image: string;
};

// vol タブの並びはシャッフル順
const volStampNameOrder = [
  "vol2_1.png",
  "vol1_4.png",
  "vol1_5.png",
  "vol1_3.png",
  "vol2_3.png",
  "vol3_2.png",
  "vol7_2.png",
  "vol6_2.png",
  "vol4_1.png",
  "vol5_1.png",
  "vol7_3.png",
  "vol5_3.png",
  "vol2_2.png",
  "vol3_3.png",
  "vol6_1.png",
  "vol6_3.png",
  "vol1_1.png",
  "vol3_1.png",
  "vol7_1.png",
  "vol4_3.png",
  "vol1_2.png",
  "vol5_2.png",
  "vol4_2.png",
];

export function sortVolStamps(stamps: Stamp[]): Stamp[] {
  return [...stamps].sort((a, b) => {
    const indexA = volStampNameOrder.indexOf(a.name);
    const indexB = volStampNameOrder.indexOf(b.name);

    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
}
